/* QA only: consent-aware Scout cart-attempt cohorts, not order attribution. */
(()=>{"use strict";if(window.__slScoutCommerceV1)return;window.__slScoutCommerceV1=true;
const consent=()=>{try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true&&typeof window.gtag==="function"}catch(_){return false}};
const read=k=>{try{const p="sl_scout_cohort_v1_";const last=Number(sessionStorage.getItem(p+"last_activity")||0);if(last&&Date.now()-last>1800000)return false;return sessionStorage.getItem(p+k)==="1"}catch(_){return false}};
const emit=(name,p)=>{if(consent())window.gtag("event",name,{event_category:"scout_commerce",...p})};
let lastClick=0;
document.addEventListener("submit",e=>{const form=e.target;if(!(form instanceof HTMLFormElement))return;
const endpoint=(form.getAttribute("action")||"").split("?")[0];if(!/\/cart\/add(?:\.js)?\/?$/.test(endpoint))return;
if(!consent())return;
const now=Date.now();if(now-lastClick<300)return;lastClick=now;
const cohort=read("engaged")?"scout_engaged":read("opened")?"scout_opened_only":"no_scout_interaction";
emit("scout_cohort_cart_attempt",{scout_cohort:cohort});
},true);
const checkoutIntent = () => {
 if(!consent()) return;
 const cohort=read("engaged")?"scout_engaged":read("opened")?"scout_opened_only":"no_scout_interaction";
 emit("scout_cohort_checkout_intent",{scout_cohort:cohort});
};
document.addEventListener("click",e=>{
 const el=e.target instanceof Element?e.target:null;
 if(!el)return;
 const link=el.closest('a[href*="/checkout"]');
 if(link)checkoutIntent();
},true);
document.addEventListener("submit",e=>{
 const f=e.target;
 if(!(f instanceof HTMLFormElement))return;
 const action=(f.getAttribute("action")||"").split("?")[0];
 if(/\/cart(?:\/)?$/.test(action)&&f.querySelector('[name="checkout"]'))checkoutIntent();
},true);
})();